export enum Levels {
  NotEligible = 1,
  Level1 = 1600,
  Level2 = 1800,
  Level3 = 2000,
  Level4 = 2002,
  Level5 = 3800,
  Level6 = 2,
  Level2A = 3801,
}

export enum LinkType {
  External = 'External',
  Internal = 'Internal',
}

export enum TollDiscount {
  Exemption = 1,
  Refund = 2,
}

export enum IturanEligibilityStatus {
  Eligible = 1,
  NotEligible = 2,
}

export enum ParkingTagStatus {
  Eligible = 1,
  NotEligible = 2,
}

export enum StepTypes {
  MarvadCheck = 1,
  BuyCar = 2,
  GetCar = 3,
  EndProcess = 4,
}

export enum TaskTypes {
  Url = 1,
  Date = 2,
  Download = 3,
  None = 4,
}
